// Colunas da listagem e título dos formulários de cada natureza (exceto pessoa, que tem o CRUD próprio).
// Os rótulos reaproveitam as chaves do formulário de envolvido (involvedForm.*), para não duplicar texto.
export const ENTITY_COLUMNS = {
  vehicle: [
    { field: 'plate', filterable: true, label: 'involvedForm.vehicle.plate.label' },
    { field: 'vehicle_type', filterable: true, label: 'involvedForm.vehicle.type.label' },
    { field: 'brand', filterable: true, label: 'involvedForm.vehicle.brand.label' },
    { field: 'model', filterable: true, label: 'involvedForm.vehicle.model.label' },
    { field: 'color', filterable: true, label: 'involvedForm.vehicle.color.label' },
  ],
  object: [
    { field: 'object_type', filterable: true, label: 'involvedForm.object.type.label' },
    { field: 'description', filterable: true, label: 'involvedForm.object.description.label' },
    { field: 'brand', filterable: true, label: 'involvedForm.object.brand.label' },
    { field: 'quantity', label: 'involvedForm.object.quantity.label' },
  ],
  property: [
    { field: 'property_type', filterable: true, label: 'involvedForm.property.type.label' },
    { field: 'address', filterable: true, label: 'involvedForm.property.address.label' },
    { field: 'reference', filterable: true, label: 'involvedForm.property.reference.label' },
  ],
  phone: [
    { field: 'number', label: 'involvedForm.phone.number.label' },
    { field: 'imei', filterable: true, label: 'involvedForm.phone.imei.label' },
    { field: 'carrier', filterable: true, label: 'involvedForm.phone.carrier.label' },
    { field: 'owner_name', filterable: true, label: 'involvedForm.phone.owner.label' },
  ],
}

export const ENTITY_TYPES = Object.keys(ENTITY_COLUMNS)

export const ENTITY_DEFAULTS = {
  vehicle: () => ({
    plate: '', vehicle_type: '', brand: '', model: '', color: '', year: '', renavam: '', chassis: '', unidentified: false, apparent_description: '', observation: '',
  }),
  object: () => ({
    object_type: '', description: '', brand: '', model: '', serial_number: '', quantity: null, estimated_value: null, observation: '',
  }),
  property: () => ({
    property_type: '', address: '', reference: '', description: '', observation: '',
  }),
  phone: () => ({
    number: '', imei: '', carrier: '', owner_name: '', observation: '',
  }),
}

// Configuração do BaseCrud (vue-tables) de cada natureza: mesmas colunas da listagem, mesmo visual das Pessoas.
// A busca é única (texto + chaves de negócio exatas); o filtro por coluna não serve a campos criptografados.
export function entityCrudConfig(vm, type) {
  const columns = ['id', ...ENTITY_COLUMNS[type].map(c => c.field), 'actions']
  const headings = { id: vm.$t('involved.crud.headings.id'), actions: vm.$t('common.actions') }
  const templates = {}
  ENTITY_COLUMNS[type].forEach(c => {
    headings[c.field] = vm.$t(c.label)
    templates[c.field] = (h, row) => (row[c.field] === null || row[c.field] === '' || row[c.field] === undefined ? '—' : String(row[c.field]))
  })

  return {
    table: `involved_${type}Table`,
    endPoint: `involved_entities/${type}`,
    columns,
    options: {
      filterByColumn: true,
      alwaysShowPerPageSelect: true,
      debounce: 1000,
      // Só filtra o que o servidor consegue buscar (colunas em claro e chaves de negócio); número do celular e
      // demais campos criptografados sem índice ficam sem filtro.
      filterable: ['id', ...ENTITY_COLUMNS[type].filter(c => c.filterable).map(c => c.field)],
      sortable: ['id'],
      sortIcon: {
        base: 'fas', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
      },
      pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
      perPage: 10,
      perPageValues: [10, 25, 50, 100],
      headings,
      templates,
      texts: { filterBy: vm.$t('involved.crud.filterBy'), defaultOption: vm.$t('common.select') },
      requestFunction(data) {
        const filters = {}
        Object.keys(data.query || {}).forEach(field => {
          filters[field] = data.query[field]
        })

        return window.axios
          .get(this.url, {
            params: {
              page: data.page, per_page: data.limit, ascending: data.ascending, filters,
            },
          })
          .catch(e => {
            this.dispatch('error', e)
          })
      },
    },
  }
}
